
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { ContactHeroSection } from './components/ContactHeroSection';
import { ContactFormSection } from './components/ContactFormSection';
import { ContactInfoSection } from './components/ContactInfoSection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function ContactPage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/contact" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <ContactHeroSection />
        <ContactFormSection />
        <ContactInfoSection />
        <FooterSection />
      </div>
    </div>
  );
}
